var map = {
	"./admin.svg": "9cca",
	"./agro.svg": "1cbd",
	"./b2b.svg": "15ef",
	"./chevron-down.svg": "ca94",
	"./despesas.svg": "9b6b",
	"./jupiter.svg": "c39c",
	"./prestacao-servico.svg": "5250",
	"./promotor.svg": "e5ed",
	"./usuarios.svg": "6667",
	"./vendas.svg": "40e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "87a3";